export const memoize = (fn) => {
	const cache = {};
	return (...args) => {
		const n = args[0];
		if (n in cache) {
			return cache[n];
		} 
		
		const result = fn.apply(null, args);
		cache[n] = result;
		return result;
	};
};